// src/components/google-maps-sdk-version-provider/google-maps-sdk-version-provider.tsx
import React, { createContext, useContext, useMemo } from "react";
var GoogleMapsSdkVersionContext = createContext({
  version: void 0
});
var useGoogleMapsSdkVersion = function () {
  return useContext(GoogleMapsSdkVersionContext);
};
function GoogleMapsSdkVersionProvider(param) {
  var version = param.version,
    children = param.children;
  var memoizedVersion = useMemo(function () {
    return {
      version: version
    };
  }, [version]);
  return /* @__PURE__ */React.createElement(GoogleMapsSdkVersionContext.Provider, {
    value: memoizedVersion
  }, children);
}
GoogleMapsSdkVersionProvider.displayName = "sharedui-GoogleMapsSdkVersionProvider";
export { GoogleMapsSdkVersionProvider, useGoogleMapsSdkVersion };